import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Button, IconButton, Paper, Stack, Typography } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Nabvar from "../../../common/Nabvar";
import Sidebar from "../../../common/Sidebar";
import { getCategoryAction } from "../../../redux/coupon/GetCategoryRTK";
import { useStyles } from "../../../theme/theme";
import Body from "../../../ui/Body";
import CreateCategory from "./CreateCategory";
import DeleteCategory from "./DeleteCategory";
import UpdateCategory from "./UpdateCategory";


// global veriables---->
let propsData = {};

export default function Categories() {
  // states------->
  const [createCategory, setCreateCategory] = useState(false);
  const [updateCategory, setUpdateCategory] = useState(false);
  const [deleteCategory, setDeleteCategory] = useState(false);

  const navigate = useNavigate();
  const dispatchRTK = useDispatch();
  const getCategorySelcter = useSelector((state) => state.getCategory);
  const { loading, data } = getCategorySelcter;
  const createCategorySelector = useSelector(state => state.createCategory);
  const { status } = createCategorySelector;
  const deleteCategoryRTK = useSelector((state) => state.deleteCategory);
  const { status: statusDeleteCategory } = deleteCategoryRTK;
  const updateCategorySelector = useSelector((state) => state.updateCategory);
  const { status: updateCategoryStatus, data: updateCategoryData } = updateCategorySelector;

  const classes = useStyles();
  const [pageSize, setPageSize] = useState(25);


  const categoryColumns = [
    {
      field: 's_no',
      headerName: 'S. No.',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      filterable: false,
      renderCell: (index) => index.api?.getRowIndexRelativeToVisibleRows(index.row._id) + 1,
    },
    {
      field: '_id',
      headerName: 'ID',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'name',
      headerName: 'Name',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'Image',
      headerName: 'image',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
      renderCell: (params) =><img src={params?.row?.image} width={"50px"}/>
        
    },
    {
      field: 'cashback_percentage',
      headerName: 'Cashback %',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 100,
    },
    {
      field: 'position',
      headerName: 'Position',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 100,
      valueFormatter: (params) => {
        const value = params.value;
        return value ? value : '---';
      }
    },
    {
      field: 'edit', headerName: 'Edit Category',
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              setUpdateCategory(true);
              propsData = {
                catId: params?.row?._id,
                name: params?.row?.name,
                cashback_percentage: params?.row?.cashback_percentage,
                position: params?.row?.position,
                image:params?.row?.image
              };
            }}><EditIcon color='primary' />
          </IconButton >
        )
      },
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'delete',
      headerName: 'Delete Category',
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              setDeleteCategory(true);
              propsData = {
                catId: params?.row?._id,
                is_deleted: true,
              };
            }}><DeleteIcon color='error' />
          </IconButton >
        )
      },
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 150,
      hide: true,
    },
    {
      field: 'created_at',
      headerName: 'Created At',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'updated_at',
      headerName: 'Updated At',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
  ]




  // useEffect
  useEffect(() => {
    dispatchRTK(getCategoryAction());
  }, [status, statusDeleteCategory, updateCategoryStatus, updateCategoryData]);

  return (
    <>
      {/* navigation section */}
      <section>
        <Sidebar />
        <Nabvar />
      </section>

      {/* body */}
      <Body>
        <Button
          variant="contained"
          sx={{ my: 2 }}
          onClick={() => setCreateCategory(true)}
        >
          Create Category
        </Button>

        <Paper sx={{
          bgcolor: '#fff',
          '& .super-app-theme--header': {
            bgcolor: '#DC8449',
            color: '#fff',
          },
        }} elevation={0}>


          <DataGrid
            className={classes.root}
            sx={{
              border: 0,
            }}
            hideFooterPagination
            // getRowHeight={() => 'auto'}
            autoHeight
            rows={data}
            columns={categoryColumns}
            getRowId={(row) => row._id}
            disableSelectionOnClick
            disableRowSelectionOnClick
            experimentalFeatures={{ newEditingApi: true }}
            //  pagination
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[25, 50, 100]}
            disableColumnSelector
          />
        </Paper>


      </Body>

      {/* modals */}
      {
        updateCategory && (
          <UpdateCategory
            updateCategory={updateCategory}
            setUpdateCategory={setUpdateCategory}
            propsData={propsData}
          />
        )
      }
      {
        createCategory && (
          <CreateCategory
            createCategory={createCategory}
            setCreateCategory={setCreateCategory}
          />
        )
      }
      {
        deleteCategory && (
          <DeleteCategory
            deleteCategory={deleteCategory}
            setDeleteCategory={setDeleteCategory}
            propsData={propsData}
          />
        )
      }
    </>
  );
}
